<div class="summary-mobile">
  <div class="initial-section">
    <p>
      {{ (step === 5 ? 'new_strategy.risk_screen.invested' : 'new_strategy.risk_screen.input1') | translate }}
      <span class="grey">{{ investmentData.currency }}</span>
    </p>
    <p class="investment">{{ (investmentData.total > 0 ? investmentData.total : 0) | translateNumber: language }}</p>
  </div>
  <div class="split-section">
    <div class="split-sub-section">
      <div>
        <p>
          <span>
            {{ 'new_strategy.risk_screen.slider.stocks' | translate }}
            <app-ui-tooltip
              [content]="
                'new_strategy.portfolio_screen.stock_ratio.tooltip'
                  | translate: { percentage: investmentData.stock_split * 100 | translatePercent: language : (step === 5 ? 1 : 0) }
              "
              size="small"
              color="yellow"
              (mouseenter)="trackTooltip('stockRatio')"
            ></app-ui-tooltip>
          </span>
          <span>
            {{ getStockBondValue('stock') | translatePercent: language : (step === 5 ? 1 : 0) }}
          </span>
        </p>
        <p>
          <span class="grey">{{ investmentData.currency }}</span>
          <strong>{{ investmentData.stocks | translateNumber: language }}</strong>
        </p>
      </div>
      <div>
        <p>
          <span class="bond-title">
            {{ 'strategy.stockSplit.bonds' | translate }}
            <app-ui-tooltip
              [content]="'bonds.tooltip.p' | translate"
              size="small"
              color="yellow"
              (mouseenter)="trackTooltip('bonds')"
            ></app-ui-tooltip>
          </span>
          <span>{{ getStockBondValue('bond') | translatePercent: language : (step === 5 ? 1 : 0) }}</span>
        </p>
        <p>
          <span class="grey">{{ investmentData.currency }}</span>
          <strong>{{ investmentData.bonds | translateNumber: language }}</strong>
        </p>
      </div>
    </div>
    <div class="bar-holder" *ngIf="investmentData.stock_split !== 0">
      <div class="bar-stocks" [style.width.%]="investmentData.stock_split * 100"></div>
    </div>
  </div>
  <div class="monhtly-section">
    <p>
      {{ 'new_strategy.risk_screen.input2' | translate }}
      <app-ui-tooltip
        [content]="'steps.id5.account_funded.tooltip_month' | translate"
        size="small"
        color="yellow"
        (mouseenter)="trackTooltip('monthly')"
      ></app-ui-tooltip>
    </p>
    <p>
      <span class="grey">{{ investmentData.currency }}</span>
      {{ investmentData.monthly_investment | translateNumber: language }}
    </p>
  </div>
</div>
